import(/* webpackMode: "eager" */ "/root/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/repo/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin/300.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin/400.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin/500.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin/600.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin/700.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin-dark/400.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin-dark/500.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin-dark/600.css");
;
import(/* webpackMode: "eager" */ "/root/repo/node_modules/@fontsource/palanquin-dark/700.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/src/components/app-bootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/root/repo/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingBarProvider"] */ "/root/repo/src/providers/loading-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalSpacetimeProvider"] */ "/root/repo/src/providers/spacetime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/root/repo/src/providers/theme.tsx");
